var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLokasjonerIkon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.78 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9615b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.61,10.38C32.13,3.62,26.37,.32,19.51,0,12.96,.12,8.09,2.41,4.34,6.89-.6,12.79-1.42,21.15,2.37,27.84c4.69,8.29,9.53,16.51,14.32,24.75,1.09,1.88,3.24,1.88,4.34,0,4.79-8.22,9.64-16.4,14.29-24.7,3.19-5.7,3.29-11.68,.29-17.51ZM15.68,28.34l.3,.04c.81,.11,1.37,.86,1.25,1.66h-5.04s-.06-.13-.06-.13l.64-3.43,.19-1.31L15.49,7.52h2.69s-2.92,20.22-2.92,20.22c-.06,.48-.03,.54,.42,.6Zm5.13,2.03l-.09-.1-.34-3.47-.18-1.32-1.48-10.46,2.59-.74,1.83,13.03c.07,.48,.12,.52,.56,.46l.3-.04c.81-.12,1.55,.45,1.66,1.25l-4.85,1.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLokasjonerIkon);
export default __webpack_public_path__ + "static/media/Lokasjoner_Ikon.ceb4e81bd26dcf4377423dd984a9a09f.svg";
export { ForwardRef as ReactComponent };